import { Colors } from "../Colors/Colors";
import { Paragraph } from "../Paragraph";
import arrowRight from "../../../assets/imgs/arrow-right.svg";
import ToggleBtn from "../Toggle/Togglebtn";
import { pulsar } from 'ldrs';

// Register the pulsar component
pulsar.register();

interface SettingItemProps {
  icon?: string;
  icon2?: string;
  text?: string;
  label: string;
  extLink?: string;
  toggle?: boolean;
  toggleState?: boolean;
  action?: (newState?: boolean) => void; // Updated type
  arrow?: boolean;
  lastItem?: boolean;
  customStyle?: string;
  isLoading?: boolean;
}

const SettingItem: React.FC<SettingItemProps> = ({
  icon,
  icon2,
  text,
  label,
  extLink,
  toggle,
  toggleState = false,
  action,
  arrow = true,
  lastItem,
  customStyle = "py-3",
  isLoading  = false,
}) => {
  // Core content of component
  const CardContent = (
    <div className="flex items-center h-10">
      <div className="flex items-center gap-2">
        {icon && <img src={icon} alt="" />}
        <Paragraph
          text={label}
          props={{
            fontSize: "15px",
            fontWeight: 600,
            letterSpacing: "-0.5px",
          }}
          ParagraphType="Paragraph22"
          color="textPrimary"
        />
        {icon2 && <img src={icon2} alt="" />}
      </div>
      <div className="ml-auto">
        {isLoading ? (
          <l-pulsar size="30" speed="1.75" color="white"></l-pulsar>
        ) : text ? (
          <Paragraph
            text={text}
            props={{
              fontSize: "15px",
              fontWeight: 600,
              letterSpacing: "-0.5px",
              color: Colors.textLigth,
            }}
            ParagraphType="Paragraph22"
            color="textPrimary"
          />
        ) : toggle ? (
          <ToggleBtn isChecked={toggleState} onToggleChange={action} />
        ) : (
          arrow && <img src={arrowRight} alt="" className="mr-2 size-[18px]" />
        )}
      </div>
    </div>
  );

  // Conditional rendering of the wrapper
  const Wrapper = extLink ? "a" : "div";
  const handleClick = (e: React.MouseEvent) => {
    if (action) {
      e.preventDefault();
      action();
    }
  };

  const wrapperProps = extLink
    ? {
        href: extLink,
        target: "_blank",
        rel: "noreferrer",
        className: customStyle,
        style: {
          borderBottom: !lastItem
            ? `1px solid ${Colors.backgroundSecundary}`
            : "",
        },
      }
    : toggle
      ? {
          className: customStyle,
          style: {
            borderBottom: !lastItem
              ? `1px solid ${Colors.backgroundSecundary}`
              : "",
          },
        }
      : {
          className: customStyle,
          style: {
            borderBottom: !lastItem
              ? `1px solid ${Colors.backgroundSecundary}`
              : "",
          },
          onClick: handleClick,
        };

  return <Wrapper {...wrapperProps}>{CardContent}</Wrapper>;

};

export default SettingItem;
